import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './status-badge.module.scss';
import { StatusBadgeVariant } from './status-badge.types';

interface StatusBadgeProps {
  variant: StatusBadgeVariant;
  label?: string;
  className?: string;
}

/**
 * Supersedes status-chip, maintenance-status-chip, survey-status, hours-badge
 * and agent-status-badge. Those stay until their screens are rewritten, since
 * most of them sit on screens the nav currently hides.
 */
export default function StatusBadge({ variant, label, className }: StatusBadgeProps) {
  const { t } = useTranslation('common');

  return (
    <span className={clsx(styles.badge, styles[`badge-${variant}`], className)}>
      {/* `||` not `??`: an empty label is a missing label, not a chosen one. */}
      {label || t(`statusBadge.${variant}`)}
    </span>
  );
}
